import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"

export const getPublishedSchedules = api(async function getPublishedSchedules({ projectId, scheduleIds }) {
    if (!projectId || !scheduleIds?.length) return []
    return query(
        gql`
            query GetPublishedSchedules($projectId: String!, $scheduleIds: [String!]!) {
                getPublishedSchedules(projectId: $projectId, scheduleIds: $scheduleIds) {
                    id
                    version
                    metadata {
                        published
                    }
                }
            }
        `,
        { projectId, scheduleIds },
        { returns: "getPublishedSchedules" }
    )
})
